module.exports = __webpack_public_path__ + "28b67065/img/menu-icon.5f8facae.svg";